import React, { useRef } from "react";
import { useAnimations, useGLTF } from "@react-three/drei";
import Music from "../Music";
import { useFrame } from "@react-three/fiber";
import { useMusic, useOutline } from "../../../common/hooks";
import {
  blackMaterial,
  grayMaterial,
  lightgrayMaterial,
} from "../../../common/materials";

const model = "/models/speakers.glb";

export default function Speakers({ ...props }) {
  const group = useRef();
  const { isPlaying, changePlaying } = useMusic();
  const { addOutline, clearOutline } = useOutline();

  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);

  useFrame(() => (isPlaying ? play() : stop()));

  const play = () => {
    Object.entries(actions).forEach(([key, value]) => {
      value.play();
    });
  };

  const stop = () => {
    Object.entries(actions).forEach(([key, value]) => {
      value.stop();
    });
  };

  const onClick = () => changePlaying();

  const onPointerEnter = (element) => {
    addOutline(element.object);
  };

  const onPointerLeave = (element) => {
    clearOutline(element.object);
  };

  return (
    <>
      <Music url="/sound/music/sunflower.mp3" />
      <group onClick={onClick} ref={group} {...props} dispose={null}>
        <mesh
          castShadow
          onPointerEnter={onPointerEnter}
          onPointerLeave={onPointerLeave}
          name="home-speakerLeft"
          geometry={nodes["home-speakerLeft"].geometry}
          material={blackMaterial}
          position={[-1.34, 2.39, 2.82]}
          rotation={[-0.17, 0, 0]}
          scale={[1.2, 1.2, 1]}
        />
        <mesh
          castShadow
          onPointerEnter={onPointerEnter}
          onPointerLeave={onPointerLeave}
          name="home-speakerRight"
          geometry={nodes["home-speakerRight"].geometry}
          material={blackMaterial}
          position={[-2.76, 2.39, 2.82]}
          rotation={[-0.17, 0, 0]}
          scale={[1.2, 1.2, 1]}
        />
        <group
          name="innerLeft"
          position={[-1.34, 2.39, 2.8]}
          rotation={[-0.19, 0, 0]}
        >
          <mesh
            name="innerSpheres"
            geometry={nodes.innerSpheres.geometry}
            material={grayMaterial}
          />
          <mesh
            name="innerSpheres_1"
            geometry={nodes.innerSpheres_1.geometry}
            material={lightgrayMaterial}
          />
        </group>
        <group
          name="innerRight"
          position={[-2.76, 2.39, 2.8]}
          rotation={[-0.19, 0, 0]}
        >
          <mesh
            name="innerSpheres001"
            geometry={nodes.innerSpheres001.geometry}
            material={grayMaterial}
          />
          <mesh
            name="innerSpheres001_1"
            geometry={nodes.innerSpheres001_1.geometry}
            material={lightgrayMaterial}
          />
        </group>
      </group>
    </>
  );
}

useGLTF.preload(model);
